/* istanbul ignore file */
import { Breakpoint } from './constants.js';
import { useMediaQuery } from './useMediaQuery.js';
export const usePhone = (options) => useMediaQuery(Breakpoint.PHONE, options);
export const useTablet = (options) => useMediaQuery(Breakpoint.TABLET, options);
export const useDesktop = (options) => useMediaQuery(Breakpoint.DESKTOP, options);
export const useWide = (options) => useMediaQuery(Breakpoint.WIDE, options);
